/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Share: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M20 15C20.5523 15 21 15.4477 21 16V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V16C3 15.4477 3.44772 15 4 15C4.55228 15 5 15.4477 5 16V19H19V16C19 15.4477 19.4477 15 20 15ZM12 2C12.2919 2 12.5688 2.12797 12.7588 2.34961L15.7588 5.84961L15.8223 5.93066C16.1112 6.34681 16.0434 6.92197 15.6504 7.25879C15.2573 7.59576 14.6786 7.57419 14.3115 7.22461L14.2412 7.15039L13 5.70215V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V5.70215L9.75879 7.15039C9.39937 7.56972 8.76893 7.61821 8.34961 7.25879C7.93028 6.89937 7.88179 6.26893 8.24121 5.84961L11.2412 2.34961L11.3164 2.27051C11.5007 2.09777 11.7447 2 12 2Z'
      fill='currentColor'
    />
  </React.Fragment>
)
